import { List, Grid, Chip, Avatar, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../../../use-cases/geo-veles";

export const CBOFilterPreview = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
  // Hook
  const { removeCBOFilter } = useProjetosService()

  return (
    <List>
      <Grid container spacing={3}>
        {filtrosSelecionados?.cbo?.map((ocupacao, index) => {
          return (
            <>
              {index === 0 && (
                <Grid item xs={12}>
                  <Typography color="primary" fontWeight="bold" gutterBottom>
                    Ocupações Selecionadas:
                  </Typography>
                </Grid>
              )}
              <Grid item key={index}>
                <Chip
                  label={ocupacao.cbodescricao ? ocupacao.cbodescricao.toUpperCase() : ''}
                  sx={{
                    height: 'auto',
                    '& .MuiChip-label': {
                      transition: '0.1s all',
                      display: 'block',
                      whiteSpace: 'normal',
                      padding: '10px 15px',
                      fontWeight: 'bold'
                    }
                  }}
                  color="primary"
                  onDelete={() => {
                    removeCBOFilter(ocupacao)
                  }}
                  avatar={
                    <Avatar sx={{
                      "&": {
                        transition: '0.1s all'
                      },
                      "&:hover": {
                        color: "secondary.main",
                        cursor: 'default'
                      }
                    }}>
                    </Avatar>
                  }
                />
              </Grid>
            </>
          )
        })}
      </Grid>
    </List>
  )
}